import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { icons } from './components/index.js';
export { icons } from './components/index.js';

var _excluded = ["name"];
var Icon = /*#__PURE__*/React__default.forwardRef(function Icon(props, ref) {
  var name = props.name,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var Component = icons[name];
  var className = cn('yt-icon', props.className);
  return Component ? React__default.createElement(Component, Object.assign({}, otherProps, {
    className: className,
    focusable: "false",
    ref: ref,
    role: "img"
  })) : null;
});

export { Icon };
//# sourceMappingURL=Icon.js.map
